import type { FlightsTranslations } from "@/service/translate/flights/flightTranslations.types"

const flightsUkTranslations: FlightsTranslations = {
    "flightPage": {
        "title": "Flight",
        "step": "Step",
        "resultsFound": "flight options found"
    },
    "flightSortBy": {
        title: "Sort by",
        price_asc: "Lowest price first",
        price_desc: "Highest price first",
        fastest: "Fastest",
        long_stay: "More skiing time"
    },
    "flightBlock": {
        "title": "Flight Block Title",
        "direct": "Direct"
    },
    "flightFilters": {
        "outboundTrip": {
            "title": "Outbound flight times",
            "duration": "Duration",

            "departure": {
                "location": "Departure airport",
                "time": "Departure"
            },
            "arrival": {
                "location": "Destination airport",
                "time": "Arrival"
            }
        },
        "inboundTrip": {
            "title": "Inbound flight times",
            "duration": "Duration",

            "departure": {
                "location": "",
                "time": "Departure"
            },
            "arrival": {
                "location": "",
                "time": "Arrival"
            }
        },
        "duration": "Flight duration",
        "airlines": "Airline"
    },
    "airportsNames": {
        "ABZ": "Aberdeen",
        "ACI": "Alderney",
        "BFS": "Belfast International",
        "BHD": "George Best Belfast City",
        "BHX": "Birmingham",
        "BOH": "Bournemouth",
        "BRS": "Bristol",
        "CWL": "Cardiff",
        "CEG": "Chester Hawarden",
        "LDY": "City of Derry",
        "CAX": "Carlisle Lake District",
        "DSA": "Doncaster Sheffield",
        "DND": "Dundee",
        "EMA": "East Midlands",
        "EDI": "Edinburgh",
        "EXT": "Exeter",
        "GCI": "Guernsey",
        "GLA": "Glasgow",
        "PIK": "Glasgow Prestwick",
        "HUY": "Humberside",
        "INV": "Inverness",
        "IOM": "Isle of Man",
        "JER": "Jersey",
        "LBA": "Leeds Bradford",
        "LPL": "Liverpool John Lennon",
        "LCY": "London City",
        "LGW": "London Gatwick",
        "LHR": "London Heathrow",
        "LTN": "London Luton",
        "SEN": "London Southend",
        "STN": "London Stansted",
        "MAN": "Manchester",
        "NCL": "Newcastle International",
        "NQY": "Newquay",
        "NWI": "Norwich",
        "SOU": "Southampton",
        "MME": "Teesside International",
        "LYS": "Lyon-Saint-Exupéry",
        "GNB": "Grenoble Alpes Isère",
        "GVA": "Genève-Cointrin",
        "CMF": "Chambéry-Savoie",
        "MFL": "Mount Full Stop Airport",
        "TRN": "Turin-Caselle",
        "SNN": "Shannon",
        "ORK": "Cork",
        "NOC": "Ireland West Knock"
    },
    "airlinesNames": {
        "U2": "easyJet",
        "LS": "Jet2.com",
        "BA": "British Airways",
        "BY": "TUI Airways",
        "LX": "Swiss International Air Lines",
        "AF": "Air France",
        "V7": "Volotea",
        "LH": "Lufthansa",
        "KL": "KLM Royal Dutch Airlines",
        "IB": "Iberia",
        "W9": "Wizz Air",
        "EI": "Aer Lingus",
        "FR": "Ryanair",
        "WW": "WOW air",
    }
}


export default flightsUkTranslations;